/* Native theme components. No commerce writes before an explicit Add to cart click. */
(() => {
  if (window.__dasheaHomeV1) return;
  window.__dasheaHomeV1 = true;
  const $ = (root, selector) => root.querySelector(selector);
  const localPreview = ['localhost', '127.0.0.1', '[::1]'].includes(location.hostname) && window.DASHEA_PREVIEW?.enabled === true;
  const concept = localPreview && window.DASHEA_PREVIEW?.concept === true;

  function attachPage() {
    const main = document.getElementById('MainContent');
    if (!main || !$(main, '.dh-hero, .dh-pdp-main')) return;
    let frame;
    const paint = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const origin = main.getBoundingClientRect().top;
        const top = selector => $(main, selector)?.getBoundingClientRect().top - origin;
        const reveal = $(main, 'dashea-scroll-reveal');
        const values = { proof: top('[data-dh-gradient="proof"]'), reveal: top('dashea-scroll-reveal'), pink: top('dashea-scroll-reveal') + (reveal?.offsetHeight || 0) * .5, clear: top('dashea-mask-transparency'), evening: top('[data-dh-gradient="evening"]') };
        for (const [key, value] of Object.entries(values)) if (Number.isFinite(value)) main.style.setProperty(`--dh-grad-${key}`, `${Math.round(value)}px`);
      });
    };
    if (main._dhGradientObserver) main._dhGradientObserver.disconnect();
    main._dhGradientObserver = new ResizeObserver(paint);
    main._dhGradientObserver.observe(main);
    paint();
    document.fonts?.ready.then(paint);
    // Customer/FAQ videos play on demand. Muted hero motion has its own component.
    main.querySelectorAll('.dh-video').forEach(video => {
      if (video.dataset.dhReady || video.closest('dashea-gallery-video')) return;
      video.dataset.dhReady = 'true';
      const frame = video.closest('.dh-video-card__frame');
      const trigger = document.createElement('button');
      trigger.type = 'button'; trigger.className = 'dh-video-play';
      trigger.setAttribute('aria-label', `Přehrát: ${video.getAttribute('aria-label') || 'video zákaznice'}`);
      trigger.innerHTML = '<span aria-hidden="true"><svg viewBox="0 0 32 32" width="25" height="25" focusable="false"><path d="m11 6 15 10-15 10Z" fill="currentColor"/></svg></span><span>Pustit video</span>';
      frame.append(trigger); video.controls = false;
      trigger.addEventListener('click', async () => {
        video.controls = true; trigger.hidden = true;
        try { await video.play(); } catch { trigger.hidden = false; video.controls = true; }
      });
      video.addEventListener('ended', () => { trigger.hidden = false; video.controls = false; });
      video.addEventListener('play', () => { trigger.hidden = true; main.querySelectorAll('.dh-video').forEach(other => { if (other !== video) other.pause(); }); });
      video.closest('details')?.addEventListener('toggle', event => { if (!event.target.open) video.pause(); });
    });
  }

  class DasheaBundle extends HTMLElement {
    connectedCallback() {
      if (this._controller) return;
      this._controller = new AbortController();
      const { signal } = this._controller;
      try { this.config = JSON.parse($(this, '[data-bundle-data]').textContent); }
      catch { this.text('[data-bundle-status]', 'Výběr nelze načíst. Otevřete prosím jednotlivý produkt.'); return; }
      this.mode = 'once'; this.plan = ''; this.busy = false; this.uncertain = false;
      this._rendered = false;
      this._animatedNodes = new Set();
      this._motion = matchMedia('(prefers-reduced-motion: reduce)');
      this._motion.addEventListener('change', () => { if (this._motion.matches) this._animatedNodes.forEach(node => node._dhValueAnimation?.cancel()); }, {signal});
      this.tiers = [...this.querySelectorAll('[data-tier]')].map(node => ({ count:Number(node.dataset.tier), rate:Number(node.dataset.rate) }));
      this.products = this.config.products.map(p => {
        const v = p.variants.find(v => v.id === p.selectedVariant) || p.variants.find(v => v.available) || p.variants[0];
        return { ...p, variants: p.variants || [], plans: p.plans || [], variantId: v?.id, qty: v?.available ? Math.min(20, Math.max(0, Math.floor(p.initial))) : 0 };
      });
      this.money = n => new Intl.NumberFormat(this.config.locale || 'cs', { style: 'currency', currency: this.config.currency, maximumFractionDigits: n % 100 === 0 ? 0 : 2 }).format(n / 100);
      for (const p of this.products) {
        const row = $(this, `[data-bundle-row="${p.key}"]`);
        const select = $(row, '[data-row-variant]');
        select.replaceChildren(...p.variants.map(v => {
          const option = document.createElement('option'); option.value = String(v.id); option.textContent = v.title + (v.available ? '' : ' — vyprodáno'); option.selected = v.id === p.variantId; return option;
        }));
        select.hidden = p.variants.length < 2;
        select.addEventListener('change', () => { if (this.busy || this.uncertain) return; p.variantId = Number(select.value); if (p.key === this.dataset.primaryKey) { const url = new URL(location.href); url.searchParams.set('variant', select.value); history.replaceState(null, '', url); } if (!this.variant(p)?.available) p.qty = 0; this.update(); }, { signal });
        row.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => {
          if (this.busy || this.uncertain || !this.variant(p)?.available) return;
          p.qty = Math.min(20, Math.max(0, p.qty + Number(button.dataset.step))); this.update();
        }, { signal }));
      }
      this.querySelectorAll('[data-mode]').forEach(button => button.addEventListener('click', () => {
        if (this.busy || this.uncertain) return;
        this.mode = button.dataset.mode; this.update();
      }, { signal }));
      $(this, '[data-plan-options]').addEventListener('change', event => {
        if (event.target.name === `plan-${this.dataset.sectionId}`) { this.plan = event.target.value; this.update(); }
      }, { signal });
      $(this, '[data-bundle-add]').addEventListener('click', () => this.add(), { signal });
      $(this, '[data-recommended-add]')?.addEventListener('click', () => this.add('recommended'), { signal });
      // Previewing the ladder is separate from applying a discount to any price.
      this.tierPreview = !concept && this.config.tierPreview === true;
      this.commerceEnabled = this.config.commerce?.enabled === true;
      if (this.commerceEnabled) this.tiers = this.config.commerce.tiers;
      $(this, '[data-bundle-progress]').hidden = !(concept || this.tierPreview || this.commerceEnabled);
      if (concept) this.text('[data-bundle-subheading]', 'Čím víc masek, tím nižší cena za kus.');
      this.update();
    }
    disconnectedCallback() { this._pdpObserver?.disconnect(); if (this.dataset.primaryKey) document.documentElement.classList.remove('dh-pdp-has-sticky'); this._controller?.abort(); this._controller = null; this._animatedNodes?.forEach(node=>node._dhValueAnimation?.cancel()); this._animatedNodes?.clear(); }
    text(selector, value) { const node = $(this, selector); if (node) node.textContent = value; }
    animatedText(selector, value) {
      const node = $(this,selector);
      if (!node || node.textContent === value) return;
      // Commit the exact final amount immediately. Motion is presentation only:
      // never count through fictitious prices or delay accessible/cart data.
      node._dhValueAnimation?.cancel();
      node.textContent = value;
      if (!this._rendered || this._motion.matches || !node.animate) return;
      this._animatedNodes.add(node);
      node._dhValueAnimation = node.animate([{opacity:.45,transform:'translateY(3px)'},{opacity:1,transform:'translateY(0)'}],{duration:260,easing:'cubic-bezier(.2,.7,.2,1)'});
    }
    maskCount(count) { return `${count} ${count === 1 ? 'maska' : count >= 2 && count <= 4 ? 'masky' : 'masek'}`; }
    variant(p) { return p.variants.find(v => v.id === p.variantId); }
    allocation(p) { return this.variant(p)?.allocations.find(a => String(a.id) === this.plan); }
    selected() { return this.products.filter(p => p.qty > 0 && this.variant(p)?.available); }
    commonPlans(selected) {
      const masks = selected.filter(p => !p.addon);
      if (!masks.length) return [];
      return masks[0].plans.filter(plan => masks.every(p => this.variant(p)?.allocations.some(a => String(a.id) === String(plan.id))));
    }
    linePrice(p) { return this.mode === 'subscription' && !p.addon ? this.allocation(p)?.price ?? this.variant(p).price : this.variant(p).price; }
    calculate() {
      const selected = this.selected();
      const count = selected.reduce((n, p) => n + (p.addon ? 0 : p.units * p.qty), 0);
      const subtotal = selected.reduce((n, p) => n + this.variant(p).price * p.qty, 0);
      const allocated = selected.reduce((n, p) => n + this.linePrice(p) * p.qty, 0);
      // Mirrors the verified automatic rules for this selection; Shopify remains
      // authoritative after add. Add-ons never qualify for quantity discounts.
      const rate = this.tierRate(count);
      const maskTotal = selected.filter(p => !p.addon).reduce((n, p) => n + this.linePrice(p) * p.qty, 0);
      const tierSaving = concept ? Math.round(maskTotal * rate / 100) : selected.filter(p => this.tierEligible(p)).reduce((n,p)=>n+Math.floor(this.linePrice(p)*rate/100)*p.qty,0);
      return { selected, count, subtotal, total: allocated - tierSaving, saving: subtotal - allocated + tierSaving, tierSaving, rate };
    }
    tierEligible(p) { return !p.addon && (concept || this.config.commerce?.productIds?.includes(p.id)); }
    tierRate(count) { return concept || this.commerceEnabled ? window.DasheaTiers.rate(concept?count:this.selected().filter(p=>this.tierEligible(p)).reduce((n,p)=>n+p.units*p.qty,0), this.tiers) : 0; }
    recommendation() {
      if (!this.commerceEnabled || !['face','eyes','neck','chest'].includes(this.dataset.primaryKey)) return null;
      const recipe = [[this.dataset.primaryKey === 'eyes' ? 'eyes' : 'face', 2], ['neck', 1], ['chest', 1]];
      const rows = recipe.map(([key, qty]) => {
        const product = this.products.find(p => p.key === key);
        return product ? { product, variant: this.variant(product), qty } : null;
      });
      // Never offer an incomplete set, a subscription-only variant, gel or an unlaunched serum.
      if (rows.some(row => !row || !this.tierEligible(row.product) || row.product.units !== 4 || !row.variant?.available || row.variant.requiresPlan || !Number.isFinite(row.variant.price))) return null;
      const count = rows.reduce((n, row) => n + row.product.units * row.qty, 0);
      const rate = window.DasheaTiers.rate(count, this.tiers);
      const subtotal = rows.reduce((n, row) => n + row.variant.price * row.qty, 0);
      const saving = rows.reduce((n, row) => n + Math.floor(row.variant.price * rate / 100) * row.qty, 0);
      return { rows, count, rate, subtotal, saving, total: subtotal - saving, payload: { items: rows.map(row => ({ id: row.variant.id, quantity: row.qty })) } };
    }
    updateRecommendation() {
      const card = $(this, '[data-bundle-recommended]');
      if (!card) return;
      const offer = this.recommendation();
      card.hidden = !offer;
      if (!offer) return;
      const list = $(card, '[data-recommended-items]');
      const signature = offer.rows.map(row => `${row.product.key}:${row.variant.id}:${row.qty}`).join('|');
      if (list.dataset.signature !== signature) {
        list.dataset.signature = signature;
        list.replaceChildren(...offer.rows.map(({product, qty}) => {
          const item = document.createElement('li');
          const sourceImage = $(this, `[data-bundle-row="${product.key}"] img`);
          if (sourceImage) { const photo = sourceImage.cloneNode(); photo.className = 'dh-recommended__photo'; photo.alt = ''; item.append(photo); }
          const label = document.createElement('strong'); label.textContent = product.label;
          const amount = document.createElement('span'); amount.textContent = this.maskCount(product.units * qty);
          item.append(label, amount); return item;
        }));
      }
      this.text('[data-recommended-total]', this.money(offer.total));
      this.text('[data-recommended-count]', `${this.maskCount(offer.count)} · 4 balení`);
      this.text('[data-recommended-saving]', this.money(offer.saving));
      this.text('[data-recommended-subtotal]', this.money(offer.subtotal));
      $(card, '.dh-recommended__saving').hidden = !offer.saving;
      this.text('[data-recommended-discount]', offer.rate ? `−${offer.rate} %` : '');
      $(card, '[data-recommended-discount]').hidden = !offer.rate;
      const button = $(card, '[data-recommended-add]');
      button.disabled = this.busy || this.uncertain;
      button.setAttribute('aria-busy', String(this.busy && this.addKind === 'recommended'));
      this.text('[data-recommended-add-label]', this.uncertain ? 'Nejdřív zkontrolujte košík' : this.busy && this.addKind === 'recommended' ? 'Přidávám celý balíček…' : 'Přidat celý balíček');
    }
    paintTierProgress(result) {
      const meter = $(this,'[data-tier-meter]');
      window.DasheaTiers.paint(meter, result.count, this.tiers);
    }
    update() {
      const selected = this.selected();
      const plans = this.commonPlans(selected);
      if (!plans.length) this.mode = 'once';
      if (!plans.some(p => String(p.id) === this.plan)) this.plan = String(plans.find(p => /8\s*(tý|ty|week)/i.test(p.name))?.id || plans[0]?.id || '');
      const planKey = plans.map(p => p.id).join(',');
      const options = $(this, '[data-plan-options]');
      if (options.dataset.key !== planKey) {
        options.dataset.key = planKey;
        options.replaceChildren(...plans.map(p => {
          const label = document.createElement('label'); label.className = 'dh-plan-option';
          const input = document.createElement('input'); input.type = 'radio'; input.name = `plan-${this.dataset.sectionId}`; input.value = String(p.id);
          const span = document.createElement('span'); span.textContent = p.name; label.append(input, span); return label;
        }));
      }
      options.querySelectorAll('input').forEach(input => { input.checked = input.value === this.plan; input.disabled = this.busy || this.uncertain; });
      this.querySelectorAll('[data-mode]').forEach(button => { button.setAttribute('aria-pressed', String(button.dataset.mode === this.mode)); button.disabled = this.busy || this.uncertain; });
      $(this, '[data-bundle-modes]').hidden = plans.length === 0;
      $(this, '[data-bundle-frequency]').hidden = this.mode !== 'subscription';
      $(this, '[data-plan-terms]').hidden = this.mode !== 'subscription';
      this.dataset.mode = this.mode;
      const maskSelection = selected.filter(p => !p.addon);
      const maskBase = maskSelection.reduce((sum,p) => sum + this.variant(p).price*p.qty,0);
      const planTotal = maskSelection.reduce((sum,p) => sum + (this.allocation(p)?.price ?? this.variant(p).price)*p.qty,0);
      const subscriptionRate = maskBase > 0 ? Math.round((1-planTotal/maskBase)*100) : 0;
      this.text('[data-subscription-rate]', subscriptionRate > 0 ? `−${subscriptionRate} %` : '');
      const selectedPlan = plans.find(p => String(p.id) === this.plan);
      this.text('[data-payment-note]', this.mode === 'subscription' ? `${selectedPlan?.name || ''} · opakované doručení a platba.` : 'Jednorázový nákup. Bez dalších zásilek.');
      for (const p of this.products) {
        const row = $(this, `[data-bundle-row="${p.key}"]`); const variant = this.variant(p);
        row.hidden = p.key !== this.dataset.primaryKey && this.dataset.hideSoldOut === 'true' && !p.variants.some(v => v.available);
        $(row, '[data-quantity-controls]').hidden = !variant?.available;
        $(row, '[data-row-stock]').hidden = !!variant?.available;
        $(row, '[data-row-variant]').disabled = this.busy || this.uncertain;
        this.animatedText(`[data-bundle-row="${p.key}"] [data-row-quantity]`, String(p.qty * (p.addon ? 1 : p.units)));
        if (variant) {
          const price = this.mode === 'subscription' && !p.addon && this.allocation(p) ? this.allocation(p).price : variant.price;
          $(row, '[data-row-price]').textContent = p.addon ? `${this.money(price)} · jednorázový doplněk` : `${this.maskCount(p.units)} · ${this.money(Math.round(price / p.units))} / ks`;
        }
        $(row, '[data-step="-1"]').disabled = !p.qty || this.busy || this.uncertain;
        $(row, '[data-step="1"]').disabled = !variant?.available || p.qty >= 20 || this.busy || this.uncertain;
      }
      const result = this.calculate();
      this.updateRecommendation();
      this.animatedText('[data-bundle-count]', `${this.maskCount(result.count)}${selected.some(p => p.addon) ? ' + doplněk' : ''}`);
      this.text('[data-bundle-subtotal]', this.money(result.subtotal));
      $(this, '[data-bundle-subtotal]').hidden = !result.saving;
      this.animatedText('[data-bundle-total]', this.money(result.total));
      this.animatedText('[data-bundle-saving]', `−${this.money(result.saving)}`);
      this.text('[data-bundle-saving-label]', this.mode === 'subscription' ? (result.rate ? 'Množství + předplatné' : 'Úspora na první doručení') : 'Množstevní sleva');
      $(this, '[data-bundle-saving-row]').hidden = !result.saving;
      this.text('[data-total-label]', this.mode === 'subscription' ? 'První doručení' : 'Celkem');
      const displayedTierRate = this.tierPreview ? window.DasheaTiers.rate(result.count, this.tiers) : result.rate;
      this.text('[data-tier-rate]', displayedTierRate ? `−${displayedTierRate} %` : '0 %');
      this.paintTierProgress(result);
      this.querySelectorAll('[data-tier]').forEach(tier => {
        const reached = result.count >= Number(tier.dataset.tier);
        tier.toggleAttribute('data-reached', reached);
        if (reached && (!tier.nextElementSibling || result.count < Number(tier.nextElementSibling.dataset.tier))) tier.setAttribute('aria-current','step'); else tier.removeAttribute('aria-current');
      });
      const next = this.tiers.find(t => t.count > result.count);
      this.text('[data-tier-next]', next ? `Ještě ${this.maskCount(next.count - result.count)} k −${next.rate} %.` : 'Nejvyšší množstevní sleva je vaše.');
      this.text('[data-bundle-mode-note]', this.mode === 'subscription' && selected.some(p => p.addon) ? 'Gel odešleme jen v první objednávce, bez předplatného.' : '');
      this.text('[data-plan-description]', plans.find(p => String(p.id) === this.plan)?.description || 'Četnost si vybíráte podle vlastní spotřeby.');
      this.text('[data-renewal]', this.renewalText(result.selected));
      const requiresPlan = selected.some(p => this.variant(p).requiresPlan && (this.mode !== 'subscription' || p.addon));
      const primary = this.products.find(p => p.key === this.dataset.primaryKey);
      const primaryUnavailable = primary && !this.variant(primary)?.available;
      const add = $(this, '[data-bundle-add]');
      this.text('[data-stock-assurance]', primaryUnavailable ? 'Tato maska je vyprodaná' : selected.length ? 'Skladem' : 'Vyberte masky');
      add.disabled = !!primaryUnavailable || !selected.length || requiresPlan || this.busy || this.uncertain;
      add.setAttribute('aria-busy', String(this.busy));
      this.text('[data-add-label]', this.uncertain ? 'Nejdřív zkontrolujte košík' : this.busy ? 'Přidávám do košíku…' : primaryUnavailable ? 'Tato maska je vyprodaná' : requiresPlan ? 'Vyberte předplatné' : !selected.length ? 'Nejdřív vyberte masky' : `Do košíku · ${this.money(result.total)}`);
      this._rendered = true;
      const extras = $(this, '[data-bundle-extras]');
      if (extras) {
        extras.hidden = !this.products.some(p => p.key !== this.dataset.primaryKey && !(this.dataset.hideSoldOut === 'true' && !p.variants.some(v => v.available)));
        const extraCount = selected.filter(p => p.key !== this.dataset.primaryKey).reduce((n,p) => n+p.qty,0);
        this.text('[data-extras-count]', extraCount ? `· ${extraCount} balení` : '');
      }
      // Read-only presentation snapshot. This element remains the only authority
      // for quantity, mode, phases, totals and cart payload; nothing is sent to analytics.
      if (this.dataset.primaryKey) {
        this.selection = { count: this.maskCount(result.count) + (selected.some(p => p.addon) ? ' + doplněk' : ''), price: this.money(result.total), mode: this.mode === 'subscription' ? `Předplatné · ${selectedPlan?.name || ''}` : 'Jednorázově', renewal: this.renewalText(selected), unavailable: !!primaryUnavailable };
        this.dispatchEvent(new CustomEvent('dashea:selection', { detail: this.selection, bubbles: true }));
      }
    }
    renewalText(selected) {
      if (this.mode !== 'subscription') return '';
      const masks = selected.filter(p => !p.addon);
      const plan = masks[0]?.plans.find(p => String(p.id) === this.plan);
      const schedule = plan?.adjustments || [];
      // Shopify provides exact allocation amounts, including subsequent phases.
      // Only summarize a combined renewal amount if every selected item shares the same schedule.
      const sameSchedule = masks.every(p => JSON.stringify(p.plans.find(x => String(x.id) === this.plan)?.adjustments) === JSON.stringify(schedule));
      if (!sameSchedule || !schedule.length) return `${plan?.name || ''}. Ceny dalších doručení podle podmínek zvoleného předplatného.`;
      const phases = schedule.map((phase, index) => {
        const rows = masks.map(p => ({ p, adjustment: this.allocation(p)?.adjustments?.[index] }));
        if (rows.some(r => !Number.isFinite(r.adjustment?.price))) return null;
        const allocatedAmount = rows.reduce((sum, r) => sum + r.adjustment.price * r.p.qty, 0);
        const tierRate = this.tierRate(masks.reduce((sum,p)=>sum+p.units*p.qty,0));
        const amount = allocatedAmount - (concept?Math.round(allocatedAmount*tierRate/100):rows.filter(r=>this.tierEligible(r.p)).reduce((n,r)=>n+Math.floor(r.adjustment.price*tierRate/100)*r.p.qty,0));
        const previous = schedule.slice(0, index).reduce((sum, a) => sum + (a.order_count || 0), 0);
        const count = phase.order_count;
        const label = index === 0 ? (!count ? 'Každé doručení' : count === 1 ? 'První doručení' : `Prvních ${count} doručení`) : (count ? `Dalších ${count} doručení` : `Od ${previous + 1}. doručení`);
        return `${label} ${this.money(amount)}`;
      }).filter(Boolean);
      return phases.length ? `${plan.name}: ${phases.join('; ')}. Ceny za jedno doručení, bez dopravy${selected.some(p => p.addon) ? ' a jednorázového gelu' : ''}.` : `${plan.name}. Další ceny ověříte v podmínkách předplatného.`;
    }
    payload() {
      return { items: this.selected().map(p => ({ id: this.variant(p).id, quantity: p.qty, ...(this.mode === 'subscription' && !p.addon ? { selling_plan: Number(this.plan) } : {}) })) };
    }
    async add(kind = 'selection') {
      const trigger = $(this, kind === 'recommended' ? '[data-recommended-add]' : '[data-bundle-add]');
      if (this.busy || this.uncertain || !trigger || trigger.disabled) return;
      const offer = kind === 'recommended' ? this.recommendation() : null;
      if (kind === 'recommended' && !offer) { this.update(); return; }
      const payload = offer ? offer.payload : this.payload();
      if (!payload.items.length) return;
      // Page-specific attribution may append private properties; this component
      // remains the single owner of selection, prices and the cart mutation.
      this.dispatchEvent(new CustomEvent('dashea:bundle-before-add', { detail: { payload, kind }, bubbles: true }));
      const status = offer ? '[data-recommended-status]' : '[data-bundle-status]';
      this.addKind = kind;
      this.busy = true; this.update(); this.text(status, '');
      const root = (this.config.root || '/').replace(/\/?$/, '/');
      if (this.hasAttribute('data-require-drawer') && !window.DasheaCart?.available) {
        this.text(status, 'Košík se nepodařilo otevřít. Obnovte stránku a zkuste to znovu.');
        this.busy = false; this.update(); return;
      }
      if (window.DasheaCart?.available) {
        try {
          await window.DasheaCart.add(payload, trigger);
          this.text(status, 'Košík byl aktualizován.');
        } catch {
          this.uncertain = true;
          this.text(status, 'Výsledek přidání zkontrolujte v košíku. Výběr jsme neopakovali.');
          this.querySelectorAll('[data-cart-recovery]').forEach(link => { link.hidden = false; });
        } finally { this.busy = false; this.update(); }
        return;
      }
      if (localPreview) {
        window.DASHEA_PREVIEW.lastPayload = payload;
        this.text(status, `Náhled: ${payload.items.reduce((n, i) => n + i.quantity, 0)} balení připraveno pro košík. Do Shopify se nic neodeslalo.`);
        this.dispatchEvent(new CustomEvent('dashea:preview-add', { detail: payload, bubbles: true }));
        this.busy = false; this.update(); return;
      }
      // The recommended-set CTA promises a drawer. Do not silently redirect or
      // write to the cart when its owner is unavailable; a fresh click can retry.
      if (offer) {
        this.text(status, 'Košík se nepodařilo otevřít. Obnovte stránku a zkuste to znovu.');
        this.busy = false; this.update(); return;
      }
      try {
        const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin', body: JSON.stringify(payload) });
        if (!response.ok) throw new Error('cart-rejected');
        // The cart is the source of truth for automatic discounts and final totals.
        window.location.assign(`${root}cart`);
      } catch {
        // A network error/422 can occur after a partial add. Never auto-retry and duplicate a purchase selection.
        this.uncertain = true;
        this.text('[data-bundle-status]', 'Přidání se nepodařilo potvrdit. Některé položky už mohou být v košíku. Než zkusíte nákup znovu, zkontrolujte prosím jeho obsah a dostupnost.');
        this.querySelectorAll('[data-cart-recovery]').forEach(link => { link.hidden = false; });
      } finally { this.busy = false; this.update(); }
    }
  }
  if (!customElements.get('dashea-bundle')) customElements.define('dashea-bundle', DasheaBundle);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', attachPage, { once: true }); else attachPage();
  document.addEventListener('shopify:section:load', attachPage);
  document.addEventListener('shopify:section:reorder', attachPage);
  document.addEventListener('shopify:section:unload', attachPage);
})();
